import { useCallback } from "react"
import {
  openPatientRoute,
  openClinicalHistoryRoute
} from "../controllers/patientNavigation"

export default function usePatientNavigationActions({
  navigate,
  effectiveClinicId,
  resolveSafeClinicId,
  selectedPatientId,
  patientSummary,
  selectedPatient
}) {
  const openPatient = useCallback(
    (patientId) => {
      openPatientRoute({
        navigate,
        patientId,
        clinicId: effectiveClinicId
      })
    },
    [navigate, effectiveClinicId]
  )

  const openClinicalHistory = useCallback(() => {
    const currentClinicId = resolveSafeClinicId()

    if (!selectedPatientId) {
      alert("No hay paciente seleccionado.")
      return
    }

    if (!currentClinicId) {
      alert("No hay una clínica válida seleccionada.")
      return
    }

    const resolvedFirstName =
      patientSummary?.patient?.firstName ||
      selectedPatient?.firstName ||
      ""

    const resolvedLastName =
      patientSummary?.patient?.lastName ||
      selectedPatient?.lastName ||
      ""

    const resolvedPhone =
      patientSummary?.patient?.phone ||
      selectedPatient?.phone ||
      ""

    openClinicalHistoryRoute({
      navigate,
      patientId: selectedPatientId,
      clinicId: currentClinicId,
      firstName: resolvedFirstName,
      lastName: resolvedLastName,
      phone: resolvedPhone
    })
  }, [
    navigate,
    resolveSafeClinicId,
    selectedPatientId,
    patientSummary,
    selectedPatient
  ])

  return {
    openPatient,
    openClinicalHistory
  }
}